
    import './styles.scoped.css';
    export default {
  "key-value-pairs": "awsui_key-value-pairs_1y9fy_13xqm_9",
  "group-title": "awsui_group-title_1y9fy_13xqm_41",
  "group-list": "awsui_group-list_1y9fy_13xqm_45",
  "group-list-item": "awsui_group-list-item_1y9fy_13xqm_55",
  "term": "awsui_term_1y9fy_13xqm_59",
  "key-label": "awsui_key-label_1y9fy_13xqm_65",
  "info": "awsui_info_1y9fy_13xqm_66",
  "detail": "awsui_detail_1y9fy_13xqm_81"
};
  